const headerTranslations = {
  en: {
    home: "Home",
    about: "About",
    batches: "Batches",
    procedure: "Procedure",
    help: "Help",
    contact: "Contact",
    admin: "Admin",
    login: "Login",
    register: "Register",
    profile: "Profile",
    logout: "Logout",
    languageLabel: "Select language",
  },
  pa: {
    home: "ਮੁੱਖ ਪੰਨਾ",
    about: "ਬਾਰੇ",
    batches: "ਬੈਚ",
    procedure: "ਪ੍ਰਕਿਰਿਆ",
    help: "ਮਦਦ",
    contact: "ਸੰਪਰਕ",
    admin: "ਐਡਮਿਨ",
    login: "ਲੌਗਇਨ",
    register: "ਰਜਿਸਟਰ ਕਰੋ",
    profile: "ਪ੍ਰੋਫਾਈਲ",
    logout: "ਲੌਗਆਉਟ",
    languageLabel: "ਭਾਸ਼ਾ ਚੁਣੋ",
  },
};

export default headerTranslations;
